import http from "@/common/http";
import Qs from 'qs'

export function getMenuList() {
    return http.get("/menu/list")
}
export function getMenuTree() {
    return http.get("/menu/tree",{
        cancel: false
    })
}


export function tableData(id) {
    return http.get(`/content/list?menuId=${ id }`)
}
export function tableData1(id, pageSize, pageNum, bool) {
    if(bool) {
        return http.get(`/content/listByPage?menuId=${ id }&display=1&pageSize=${ pageSize }&pageNum=${ pageNum }`)
    }else {
        return http.get(`/content/listByPage?menuId=${ id }&pageSize=${ pageSize }&pageNum=${ pageNum }`)
    }

}
export function getContentById(id) {
    return http.get(`/content/getById?id=${ id }`)
}
export function getAllResource(id) {
    return http.get(`/content/subListByMenuId?menuId=${ id }`)
}
export function getMenuInfo(id) {
    return http.get(`/menu/getById?id=${ id }`)
}
export function roundById(id) {
    return http.get(`/content/roundById?id=${id}`)
}
export function subMenuListById(id) {
    return http.get(`/menu/getSubListById?id=${id}`)
}
export function getFooterMenuList() {
    return http.get(`/menu/footerTree`,{
        cancel: false
    })
}
export function searchContent(params) {
    return http.get(`/content/search?${Qs.stringify(params)}`)
}
export function labelList() {
    return http.get(`/label/list`,{
        cancel: false
    })
}
